import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../commons/Icon';

import RobotIcon from '../../assets/icons/robot.svg';

const MaintenanceEquipment = ({ code, name, onClick }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        columnGap: '10px',
        cursor: 'pointer',
      }}
      onClick={() => onClick()}
    >
      <div
        style={{
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#dedede',
          backgroundColor: '#dedede',
          borderRadius: '5px',
          padding: '3px',
        }}
      >
        <Icon svg={RobotIcon} size={40} transparent />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: '#808080', fontSize: '14px' }}>{code}</span>
        <span style={{ fontWeight: 'bolder' }}>{name}</span>
      </div>
    </div>
  );
};

MaintenanceEquipment.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default MaintenanceEquipment;
